import { useEffect,useState } from 'react'
import { Class } from '../../../../types/dataModel';
import {API} from '../../../../common/Constants'
import useFetch from '../../../../hooks/useFetch';
import PreLoader from '../../../../core/common/preLoader';
import { getAPIHeaders, isNotEmpty, toCamelCase } from '../../../../common/Utils';
import { Link } from 'react-router-dom'
import CommonSelect from '../../../../core/common/commonSelect';

interface Props {
  onSuccess: ()=> void
  currCoursesOpts: any[]
}


const AddClass = ({onSuccess,  currCoursesOpts}:Props) => {
  const [clazz, setClazz] = useState<Class>()
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");
  const {isLoading, error, data, status, callFetch } = useFetch();
  const [showMsgBox, setShowMsgBox] = useState<boolean>(false)

    useEffect(() => {
          if(data && status && status < 299){
              reset();
              setShowMsgBox(true)
              onSuccess()
          }
     }, [status]);

    useEffect(() => {
        if(error){
          if(error.response?.data){
            setErrorMessage(error.response?.data)
          } else{
            setErrorMessage('Something went wrong please try again later.')
          }
        }
    }, [error]);

  const handleSubmit = (event:any) => {
      event.preventDefault()
      if(!isNotEmpty(clazz?.name)){
        setErrorMessage("Please provide Batch name")
      } else if(!isNotEmpty(clazz?.section)){
        setErrorMessage("Please provide Section name")
      } else if(!isNotEmpty(clazz?.curriculumCourseId)){
        setErrorMessage("Please select a Curriculum Course")
      } else {
        setErrorMessage("")
        callFetch(API.CLASS,
            'POST',
            getAPIHeaders(),
            null,
            {
                ...clazz
            }
        ).catch(()=>{
          setErrorMessage(error?.response?.data || "Something went wrong please try again later.")
        });
      }
    }

    const reset = () => {
      setClazz({
        name:"",
        section:"",
        curriculumCourseId:0
      })
      setErrorMessage("")
      setShowMsgBox(false)
    }

    const renderForm = () => {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Add Class</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Curriculum - Course</label>
                    <CommonSelect
                      className='select'
                      options={currCoursesOpts.filter((currCourse) => currCourse.curriculumStatus !== "INACTIVE")} // Exclude INACTIVE curriculums
                      onChange={(value)=>{
                        setClazz({
                          ...clazz,
                          curriculumCourseId: parseInt(value)
                        })
                      }}
                      formatOptionLabel={(item)=>{
                        return (
                          <div className="p-2">
                          <h6>
                            {item?.data?.courseTitle}
                            <span
                              className={`ms-2 badge rounded-pill bg-${
                                item?.data?.curriculumStatus === "ACTIVE"
                                  ? "success"
                                  : item?.data?.curriculumStatus === "UPCOMING"
                                  ? "info"
                                  : "primary"
                              }`}
                            >
                              {toCamelCase(item?.data?.curriculumStatus)}
                            </span>
                          </h6>
                          <span className="text-gray fs-12"> {item?.data?.curriculumTitle}</span>
                        </div>
                        )
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Batch Name <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control" 
                    value={clazz?.batchName}
                    onChange={(e)=>{
                      setClazz({
                        ...clazz,
                        name: e.target.value
                      })
                    }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Section <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control"
                        value={clazz?.batchSection}
                        onChange={(e)=>{
                            setClazz({
                                ...clazz,
                                section: e.target.value
                            })
                        }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ 
                justifyContent: "space-between",
                flexDirection:'row'}}>
                <div style={{maxWidth:"50%"}}>
                        { errorMessage  ?
                          <>
                            <i className="ti ti-alert-triangle text-danger" />  
                            <span className='text-danger'> {errorMessage} </span> 
                          </> 
                          : <></>
                        }
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={reset}
                  >
                    Cancel
                  </button>
                  <button type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}>
                    Add Class
                  </button>
              </div>
            </div>
          </form>
        </div>
      )
    }

    const renderMsgBox = () => {
      return (          
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  <i className="ti ti-thumb-up fs-36" />
              </span>
              <h4 className="mb-1">Add Batch Successfull</h4>
              <p className="mb-3">
                  Batch is added successfully.
              </p>
              <div className="d-flex justify-content-center">
                  <Link to="#" 
                      data-bs-dismiss="modal" 
                      className="btn btn-success"
                      onClick={()=>{
                        setTimeout(() => {
                          setShowMsgBox(false);
                        }, 1000);
                        }}>
                      Close
                  </Link>
              </div>
          </div>
      </div>
    </div>)
    } 

    return (
      <div className="modal-dialog modal-dialog-centered modal-md"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
        <PreLoader showLoader={isLoading} />
        {showMsgBox ? renderMsgBox() : renderForm()}
      </div>
    )
}


export default  AddClass